module.exports = __webpack_public_path__ + "static/media/davis_jojy.6f379f47.png";